export default function LeftLine() {
  return <svg
    className="line"
    xmlns="http://www.w3.org/2000/svg"
    width="99"
    height="120"
    fill="none"
    viewBox="0 0 99 120"
  >
    <path stroke="#E42436" strokeWidth="6" d="m3.49 132.356 93-142"></path>
  </svg>;
}
